(function () {
    'use strict';
    angular
        .module('app')
        .controller('confirmBox', confirmBox);
    confirmBox.$inject = ['$rootScope', '$scope', '$mdDialog', 'loginService'];
    function confirmBox($rootScope, scope, $mdDialog, loginService) {
        scope.loginService = loginService;

        // Initialized in confirmBoxShow.
        scope.confirmBox = $rootScope.confirmBox;

        scope.sendEvents = function (bOK) {
            // Close the dialog.
            $mdDialog.hide();
            // Fire the POST event.
            if (scope.confirmBox.postCloseCallback != null)
                scope.confirmBox.postCloseCallback($rootScope.confirmBox.param1, $rootScope.confirmBox.param2, bOK);
        }

        scope.onConfirmBoxOK = function () {
            scope.sendEvents(true);
        }

        scope.onConfirmBoxCancel = function () {
            scope.sendEvents(false);
        }

        function activate() { }
        activate();
    }
})();
